import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { environment } from '../environments/environment';
import { Provider } from '@angular/core';
import { LIBRARY_CONFIG } from '@gea/digital-ui-lib';
import {
  BASE_URL,
  HRT_BASE_URL,
  HRT_FAULT_DB_BASE_URL,
  HRT_FAULT_DB_SUBSCRIPTION_KEY,
  HRT_SUBSCRIPTION_KEY,
  ICON_PATH,
  PACKAGE_VERSION,
  STORAGE_URL,
  SUBSCRIPTION_KEY,
} from './shared/utils/tokens';
import packageJson from '../../package.json';

export const APP_PROVIDERS: Provider[] = [
  {
    provide: STORAGE_URL,
    useValue: 'https://content.apps.gea.com/strg-container-i18n/',
  },
  {
    provide: HRT_BASE_URL,
    useValue: environment.hrt.baseURL ?? environment.baseURL,
  },
  { provide: BASE_URL, useValue: environment.baseURL },
  // The library injects the string token 'baseUrl' for MSAL interceptor and API config.
  { provide: 'baseUrl', useValue: environment.baseURL },
  {
    provide: ICON_PATH,
    useValue: 'https://content.apps.gea.com/strg-container-apps/core/portal/icons/',
  },
  {
    provide: HRT_FAULT_DB_BASE_URL,
    useValue: environment.hrtFaultdatabase?.baseUrl ?? '',
  },
  {
    provide: HRT_FAULT_DB_SUBSCRIPTION_KEY,
    useValue: environment.hrtFaultdatabase?.subscriptionKey ?? '',
  },
  { provide: HRT_SUBSCRIPTION_KEY, useValue: environment.hrt.subscriptionKey },
  { provide: SUBSCRIPTION_KEY, useValue: environment.subscriptionKey },
  {
    provide: PACKAGE_VERSION,
    useFactory: () => packageJson.version,
  },
  {
    provide: LIBRARY_CONFIG,
    useFactory: () => {
      return {
        ...environment,
        legalDocumentsStorageURL: '',
        passwordResetAuthority: environment.oAuth.passwordResetAuthority,
        baseUrl: environment.baseURL,
        iconStorageURL: 'https://content.apps.gea.com/strg-container-apps/core/portal/icons/',
        backendInfoUrl: environment.baseURL + 'geaid/v1/info',
      };
    },
  },
  MsalService,
  MsalBroadcastService,
  MessageService,
  ConfirmationService,
  DialogService,
  DynamicDialogConfig,
];
